import { useClientStore } from "@/store/client";

export const pageMonCompteMesCommandesEnMagasinProps = () => ({
  isFidCarrefour: {
    type: Boolean,
    required: false,
    default: false
  },
  achatsMagasin: {
    type: Array,
    required: false,
    default: []
  },
  error: {
    type: Number,
    required: false,
    default: false
  },
  achatIsLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  listeMagasins: {
    type: Array,
    required: false,
    default: []
  },
  appliedFilters: {
    type: Array,
    required: false,
    default: () => []
  },
  queryFilters: {
    type: Object,
    required: false,
    default: () => { }
  },
  keyPeriode: {
    type: String,
    required: false,
    default: ""
  },
  filtersDisplay: {
    type: Boolean,
    required: false,
    default: true
  },
  showSeeMoreResults: {
    type: Boolean,
    required: false,
    default: true
  },
  isMagasinTeasing: {
    type: Boolean,
    required: false,
    default: false
  },
  hasCarteCarrefour: {
    type: Boolean,
    required: false,
    default: false
  },
  typeAchat: {
    type: String,
    required: false,
    default: "enMagasin"
  }
})

export const pageMonCompteMesCommandesEnMagasinEmits = () => ([
  "appliquerFiltres",
  "supprimerFiltre"
])

export const usePageMonCompteMesCommandesEnMagasin = (context, props) => {
  const clientStore = useClientStore();
  const libellePeriode = ref(null);

  const { isPorteurCarteCora, isPorteurCarteMalin } = storeToRefs(clientStore);


  const { setPopinAjoutCarteVisible } = clientStore;

  const appliquerFiltre = (filtres, libelle) => {
    context.emit('appliquerFiltres', filtres, libelle)
  }
  const supprimerFiltre = (_checked, code) => {
    context.emit('supprimerFiltre', code)
  }
  const setPopinAjoutCarte = () => {
    setPopinAjoutCarteVisible(true);
  }
  const setPeriodeLibelle = (newLibelle) => {
    libellePeriode.value = newLibelle
  }

  const canDisplayBanner = computed(() => {
    return props.isFidCarrefour && props.hasCarteCarrefour && props.achatsMagasin.length > 0
  })

  return {
    canDisplayBanner,
    libellePeriode,
    isPorteurCarteCora,
    isPorteurCarteMalin,
    appliquerFiltre,
    supprimerFiltre,
    setPopinAjoutCarte,
    setPeriodeLibelle
  }
}